import { render, staticRenderFns } from "./BuildingList.vue?vue&type=template&id=2e2b148c"
import script from "./BuildingList.vue?vue&type=script&lang=js"
export * from "./BuildingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports